import { Component, OnInit, Inject, ViewChild } from '@angular/core';

import { PopupComponent } from '~Components/popup/popup.component';
import { BaseComponent } from '~Interfaces/basecomponent';

import { FeedbackService } from '~Services/feedback.service';

/**
 * Composant de factures
 * @extends BaseComponent
 * @implements OnInit
 */
@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.scss']
})
export class FeedbackComponent extends BaseComponent implements OnInit {

    message: string = '';

    @ViewChild('popupFeedback', { static: false }) popupFeedback: PopupComponent;

    /**
     * Constructeur
     */
    constructor(@Inject(FeedbackService) private feedbackService: FeedbackService) { super(); }

    /**
     * Initialisation du composant
     */
    ngOnInit() {
    }

    /**
     * Envoyer le message
     */
    envoyerMessage() {
        this.feedbackService.envoyerFeedback(this.message).subscribe(retour => {
            this.fermerPopup();
        }, err => {
            console.error(err);
            this.fermerPopup();
        });
    }

    /**
     * Bouton appliquer de la popup
     */
    appliquer() {
        if (this.message) {
            this.envoyerMessage();
        }
    }

    /**
     * Ouverture de la popup
     */
    ouvrir() {
        this.message = '';
        return true;
    }

    /**
     * Fermer la popup
     */
    private fermerPopup() {
        if (this.popupFeedback) {
            this.popupFeedback.fermer();
        }
    }
}
